/*eslint-disable*/
import React, { Component, Suspense } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  Row,
  Col,
  CardHeader,
  Badge,
  Label,
  CardTitle,
} from "reactstrap";
import TablesEvent from "./tablesEvent";
const Table = React.lazy(() => import("../../../../../Components/Table"));
const StepperEvent = React.lazy(() =>
  import("../../../../../Components/StepperEvent")
);

class EventContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dato: [],
      allSteps: [],
      allTables: [],
      columns: [
        {
          label: "Event Description",
          key: "EventDescription",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        {
          label: "Event Date",
          key: "EventDate",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        {
          label: "Category Responsible",
          key: "CategoryResponsable",
          idTh: "firstTh",
          idTd: "firstTd",
        },
        { label: "Name", key: "Origin", idTh: "firstTh", idTd: "firstTd" },
        {
          label: "Update Date",
          key: "CreateDate",
          idTh: "firstTh",
          idTd: "firstTd",
        },
      ],
      steps: [
        {
          label: "Booking request",
          value: "",
          id: 1,
          completed: false,
          order: 1,
          idStep: "step1",
          middleStep: "",
        },
        {
          label: "Booking Confirmation",
          value: "",
          id: 2,
          completed: false,
          order: 2,
          idStep: "step2",
          middleStep: "",
        },
        {
          label: "ATD",
          value: "",
          id: 4,
          completed: false,
          order: 4,
          idStep: "step4",
          middleStep: "",
        },
        {
          label: "ATA",
          value: "",
          id: 5,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
        },
        {
          label: "Out of Gate",
          value: "",
          id: 8,
          completed: false,
          order: 8,
          idStep: "step8",
          middleStep: "",
        },
        {
          label: "Empty Returned",
          value: "",
          id: 9,
          completed: false,
          order: 9,
          idStep: "step9",
          middleStep: "",
        },
      ],
    };
  }

  componentDidMount = () => {
    // this.props.steps.sort(function(a, b) {return a.order - b.order});
    this.setState(
      {
        allSteps: this.props.allSteps,
        steps: this.props.steps,
        doEmbarque: this.props.data.ShipmentNumber,
        noContenedor: this.props.data.NoContainer,
      },
      () => {
        this.createTables();
      }
    );
  };

  componentWillReceiveProps = (nextProps) => {
    // nextProps.steps.sort(function(a, b) {return a.order - b.order});
    // nextProps.steps.sort(function (a, b) { return a.order - b.order });
    this.setState(
      {
        allSteps: nextProps.allSteps,
        steps: this.props.steps,
        doEmbarque: nextProps.ShipmentNumber,
        noContenedor: nextProps.NoContainer,
      },
      () => {
        this.createTables();
      }
    );
  };

  createTables = () => {
    var allTables = [];
    this.state.allSteps.map((e) => {
      var findTable = false;
      allTables.map((f) => {
        if (f.eventType === e.EventType) {
          f.data.push(e);
          findTable = true;
        }
        return f;
      });
      if (!findTable) {
        var obj = {
          eventType: e.EventType,
          data: [e],
        };
        allTables.push(obj);
      }
      return e;
    });
    this.setState({ allTables: allTables });
  };

  render() {
    const { Logistics, loadingTotals, data, dataContainer } = this.state;

    return (
      <>
        <Card className="myCard">
          <CardBody>
            <div className="row" style={{ marginLeft: 15 }}>
              <em className="fa-2x mr-2 fas fa-shopping-basket"></em>
              <div className="col">
                <b>{"Container No."}</b>{" "}
                <span>
                  <b>{this.state.noContenedor}</b>
                </span>
                <br />
                <b>{"Shipment No."}</b>{" "}
                <span>
                  <b>{this.state.doEmbarque}</b>
                </span>
              </div>
            </div>
            <div className="col-12">
              <Suspense fallback={<div>Loading...</div>}>
                {" "}
                <StepperEvent steps={this.state.steps} />
              </Suspense>
            </div>
          </CardBody>
        </Card>
        <Card className="myCard">
          <CardBody>
            <div className="row">
              <div className="col-12">
                <Suspense fallback={<div>Loading...</div>}>
                  {this.state.allTables.length > 0 ? (
                    <TablesEvent
                      columns={this.state.columns}
                      allTables={this.state.allTables}
                    />
                  ) : (
                    <Table
                      columns={this.state.columns}
                      data={this.state.dato}
                      options={{
                        large: false,
                        downloads: {
                          pdf: false,
                          xlsx: false,
                        },
                      }}
                    />
                  )}
                </Suspense>
              </div>
            </div>
          </CardBody>
        </Card>
      </>
    );
  }
}

export default EventContainer;
